<template>
  <v-card flat>
    <v-card-title class="font-weight-bold">Configurar e-mail</v-card-title>
    <v-card-text>
      <v-form ref="form">
        <v-text-field
          v-model="email"
          label="E-mail"
          :rules="emailRules"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn
        rounded
        color="success"
        min-width="110"
        :loading="confirmando"
        @click="confirmarEmail()"
        >Confirmar</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  computed: mapState("usuario", ["usuarioLogado"]),
  data: () => ({
    email: "",
    emailRules: [
      (v) =>
        !v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "Informe corretamente o e-mail",
      (v) => !!v || "Informe um e-mail",
    ],
    confirmando: false,
  }),
  methods: {
    async confirmarEmail() {
      this.confirmando = true;
      await axios
        .post("/colaborador/usuarios?action=CONFIG-EMAIL", {
          email: this.email,
        })
        .then((res) => {
          if (res.data.success) {
            this.usuarioLogado.email = this.email;
            this.$toasted.success(res.data.msg);
          } else this.$toasted.error(res.data.msg);
        })
        .catch((e) => this.$toasted.error(e));
      this.confirmando = false;
    },
  },
  created() {
    this.email = this.usuarioLogado.email;
  },
};
</script>

<style>
</style>